import { render, staticRenderFns } from "./pop_up_preview.vue?vue&type=template&id=2b8ce370&scoped=true&lang=pug&"
import script from "./pop_up_preview.vue?vue&type=script&lang=js&"
export * from "./pop_up_preview.vue?vue&type=script&lang=js&"
import style0 from "./pop_up_preview.vue?vue&type=style&index=0&id=2b8ce370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8ce370",
  null
  
)

export default component.exports